import React from 'react';
import Select from "react-select";
import {Col, Input, Row} from "reactstrap";
import TextLabel from "../../../../../Controls/TextLabel.mjs";

const G = window.glob;

const buildOptions = () => {
	const player = G.getStatus('Player')||{};
	const roles = player?.roles || [];
	return roles.map( r => ({ value: r.id, label: r.name }))
		.sort((a, b) => ( a.label > b.label ? 1 : -1 ));
}

const buildValue = ( m = {} ) =>{
	const player = G.getStatus('Player')||{};
	const roles = player?.roles || [];
	const v = (m?.from ? roles.find( r => r.id === m.from ) : null)|| '';
	if ( v ) return { value: v.id, label: v.name };
	return '';
};

const MailEditorFrom = class extends React.Component {
	constructor(props) {
		super(props);
		const m = props.message || {};
		this.state = { message: m };
		this.autoValue = this.autoValue.bind(this);
		this.onChange = this.onChange.bind(this);
	}
	autoValue() {
		if ( this.state.value && this.state.value.id ) return this.state.value;
		const m = this.props.getter();
		let v = '';
		const player = G.getStatus('Player') || {};
		const roles = player?.roles || [];
		const canChange = roles.length > 1;
		const ns = { canChange: canChange };
		if ( m.from ) {
			v = buildValue(m);
		} else if ( ! canChange && roles[0]?.id) {
			m.from = roles[0].id;
			v = buildValue(m);
		}
		if (v) {
			ns.value = v;
			setTimeout(() => {
				this.setState(ns);
				this.props.setter(m);
			}, 100);
		} else {
			setTimeout(() => {
				this.setState(ns);
			}, 100);
		}
		return v;
	}
	onChange = (v) => {
		const m = this.props.getter();
		m.from = v?.value;
		this.setState( { value: v, message: m });
		this.props.setter( m );
	};
	render() {
		return(
			<Row className={ this.props.error ? 'select error': 'select'}>
				<Col className={"nomobile"}>
					<TextLabel value={"From"} />
				</Col>
				<Col>
					{
						this.state.canChange ? (
							<Select
								menuPortalTarget={document.body}
								styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								placeholder={ G.label('From') }
								value={ this.state.value ?? this.autoValue() }
								options={ buildOptions( this.state.message ) }
								onChange={ this.onChange }
							/>
						) : (
						<Input
							type="text"
							disabled={ true }
							value={ (this.state.value ?? this.autoValue())?.label }
						/>
						)
					}
				</Col>
			</Row>
		)
	}
};

export default MailEditorFrom;
